import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ItineraryService extends HttpService {
  
  url:any;

  constructor(http: HttpClient) { 
    super('',http);
  }
 
  getFilter() {
    return this.get().map(res => {
      return res['data'];
    }); 
  }

  storeDetail(data){
    return this.http.post(this.url, data).map((dataResponse) => {
      return dataResponse;
    });
   }

  updateDetail(id,data) {
    return this.http.put(this.url + '/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }  

}